import { useState, useEffect, FC } from "react";

const LoadingAnimation: FC<LoadingAnimationProps> = ({
  loadingText = "Loading",
  dotNumber = 3,
}) => {
  const [loadingTxt, setLoadingTxt] = useState(loadingText);

  useEffect(() => {
    let tick = 0;
    const interval = setInterval(() => {
      setLoadingTxt(loadingText + ".".repeat(tick));
      tick = (tick + 1) % (dotNumber + 1);
    }, 500);

    return () => clearInterval(interval); // Cleanup on component unmount
  }, [loadingText, dotNumber]);

  return <div>{loadingTxt}</div>;
};

export default LoadingAnimation;

interface LoadingAnimationProps {
  loadingText?: string;
  dotNumber?: number;
}
